"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
function ILNavigationBanner(props) {
    var title = props.title, subtitle = props.subtitle, image = props.image, description = props.description, actionLink = props.actionLink, actionText = props.actionText, imageSrc = props.imageSrc, action = props.action, sx = props.sx, children = props.children, className = props.className, titleSx = props.titleSx, _a = props.lightTitle, lightTitle = _a === void 0 ? true : _a;
    var classes = 'il-navigation-banner ' + className;
    var renderDescription = description instanceof Function ? description(props) : description;
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: __assign({ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }, sx) },
        react_1.default.createElement(material_1.Box, { maxWidth: "sm", sx: __assign({ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: '1.5rem' }, sx) },
            title && (react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H1, color: lightTitle ? 'primary.contrastText' : 'primary.dark', sx: __assign({ fontSize: 46 }, titleSx) }, title)),
            imageSrc && (react_1.default.createElement("img", { style: { maxWidth: '320px' }, src: imageSrc, alt: "Default screen artwork" })),
            image,
            subtitle && (react_1.default.createElement(material_1.Typography, { color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY1, sx: { fontWeight: 'bold' } }, subtitle)),
            renderDescription && (react_1.default.createElement(material_1.Typography, { sx: { textAlign: 'center' }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY1 }, renderDescription)),
            actionText && react_1.default.createElement(il_button_1.ILButton, { component: material_1.Link, href: actionLink }, actionText),
            action,
            children)));
}
exports.default = ILNavigationBanner;
